export default __webpack_public_path__ + "static/media/catalog_step_img03.f5de7536.svg";